<template>
    <div v-show="visible">
        <el-dialog title="设置会员特权" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="35%">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="会员特权">
                    <el-select v-model="form.privilegeIds" multiple filterable collapse-tags placeholder="请选择会员特权" style="width:100%;">
                        <el-option
                            v-for="item in privilegeOptions"
                            :key="item.id"
                            :label="item.remark ? (item.remark + '（' + privilegeLabel(item.projectType) + '）') : privilegeLabel(item.projectType)"
                            :value="String(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';

export default {
    data(){
        return{
            visible: false,
            form: {
                id: '',
                privilegeIds: []
            },
            privilegeOptions: []
        };
    },
    methods:{
        init(data){
            this.visible = true;
            this.form.id = data.id;
            if(this.$util.isNotEmpty(data.privilegeIds)){
                this.form.privilegeIds = String(data.privilegeIds).split(',');
            }else{
                this.form.privilegeIds = [];
            }
            this.getPrivilegeOptions();
        },
        dialogClose(done){
            done();
            this.$reload;
        },
        getPrivilegeOptions(){
            let url = this.memberPrivilegeListUrl;
            let data = {
                isPage: 0
            };
            this.apiPost(url,data).then((res)=>{
                if(res.status === 200){
                    this.privilegeOptions = res.data.list || res.data.data || [];
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            },(err)=>{
                console.log(err);
            });
        },
        save(){
            let url = this.memberProductSetPrivilegeUrl;
            let data = {
                id: this.form.id,
                privilegeIds: this.form.privilegeIds.join(',')
            };
            this.apiPost(url, data).then((res) => {
                if(res.status === 200){
                    this.$commonFn.showTip(res.message,1);
                    this.visible = false;
                    this.$parent.getData();
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            }, (err) => {
                console.log(err);
            });
        },
        privilegeLabel(v){
            if(v == 1 || v == '1') return 'AI智伴';
            if(v == 2 || v == '2') return '校园通话';
            if(v == 3 || v == '3') return '语音留言';
            if(v == 4 || v == '4') return '智能校徽';
            return '未知项目';
        }
    },
    mixins: [http]
};
</script>



// WEBPACK FOOTER //
// src/components/page/member/product/SetPrivilege.vue